export const HOMEPAGE_PATH = '/';
export const AUTH_PATH = '/auth';
export const LOGIN_PATH = '/login';
export const SIGNOUT_PATH = '/signout';
export const REGISTER_PATH = '/register';
export const PARKS_PATH = '/parks';
export const BOOK_PATH = '/book';
export const BOOK_COTTAGE_PATH = '/book-cottage';
export const BOOK_MAINTENANCE_PATH = '/book-maintenance';
export const RESERVATIONS_PATH = '/reservations';
export const SERVICE_ENTRY_PATH = '/service-entries';
export const PROFILE_PATH = '/profile';
export const CONFIRMATION_PATH = '/confirmation';
export const RESERVATION_DETAIL_PATH = '/reservation';
export const RESERVATIONS_EXTENSION_PATH = '/reservation-extension';
export const FINNISH_REGISTER_PATH = '/liity';
export const PAYMENT_REDIRECT_PATH = '/payment-redirect';

// reservations
export const SLOT_COUNT_PATH = `${RESERVATIONS_PATH}/slots`;
export const REGISTRATION_PATH = `${RESERVATIONS_PATH}/registration`;
export const GUEST_INFORMATION_PATH = `${RESERVATIONS_PATH}/guest-information`;
export const PARKING_SPOT_PATH = `${RESERVATIONS_PATH}/select-parking-spot`;
export const SERVICES_PATH = `${RESERVATIONS_PATH}/additional-services`;
export const PAYMENT_PATH = `${RESERVATIONS_PATH}/payment`;

// reservations extensions
export const EXTENSION_PAYMENT_PATH = `${RESERVATIONS_EXTENSION_PATH}/:id/payment`;

// service entry flow
export const SELECT_DATE_PATH = `${SERVICE_ENTRY_PATH}/select-date`;
export const CONTACT_DETAILS_PATH = `${SERVICE_ENTRY_PATH}/contact-details`;
export const SERVICE_PAYMENT_PATH = `${SERVICE_ENTRY_PATH}/payment`;
export const SERVICE_PAYMENT_REDIRECT_PATH = `${SERVICE_ENTRY_PATH}/payment-redirect`;
export const SERVICE_PAYMENT_NOTIFY_PATH = `${SERVICE_ENTRY_PATH}/paytrail-notify`;
export const SERVICE_PAYMENT_CONFIRMATION_PATH = `${SERVICE_ENTRY_PATH}/confirmation`;
export const SERVICE_ENTRY_DETAILS = `${SERVICE_ENTRY_PATH}/details`;

// profile
export const PROFILE_EDIT_PATH = `${PROFILE_PATH}/edit`;

// social links
export const FB_PATH = 'https://www.facebook.com/BestParkfi-108861784131203/';
export const YOUTUBE_PATH =
  'https://www.youtube.com/channel/UCJPTUYZE-k7UzFZL8VU1JZg';
export const LINKED_IN_PATH = 'https://www.linkedin.com/company/43342542';
export const INSTAGRAM_PATH = 'https://www.instagram.com/bestpark_oy/';

export enum REDIRECT_STRINGS {
  SERVICE_ENTRY = 'service_entry',
}

// BESTPARK-WP MENUS
export const OUR_STORY = '/introduction';
export const FOR_HOSTS = '/hosts';
export const THE_CITIES = '/cities';
export const CONTACT_US = '/contact';
export const TERMS = '/terms';
export const PRIVACY_POLICY = '/privacy';
export const MEDIA = '/media';
export const BESTPOINT_PATH = '/bestpoint-service-point';
export const WHY_BESTPARK_PATH = '/why-bestpark';
export const INFO_PATH = '/info';
